<!--
Author: ia
Create Time: 2019-07-23 09:45:01
Description: simplfy-table [refers](https://juejin.im/post/5a100d09f265da4324800807)
-->
<template>
  <el-table class="com-simplfy-table" :data="data" v-bind="{...$props, ...$attrs}" v-on="$listeners">
      <template v-for="(colConfig, colConfigIndex) in colConfigs">
        <slot
          v-if="colConfig.slot"
          :name="colConfig.slot"

          :colConfig="colConfig"
        ></slot>
        <component
          v-else-if="colConfig.component"
          :is="colConfig.component"
          :key="[colConfig.key||'', colConfigIndex].join('|')"
          :colConfig="colConfig"
          v-bind:attrs="colConfig.noAutoBindAttrs ? {} : colConfig"
        ></component>
        <el-table-column
          v-else
          :key="[colConfig.key||'', colConfigIndex].join('|')"
          v-bind="colConfig"
        ></el-table-column>
      </template>
    </el-table>
</template>

<script>
export default {
  name: 'simplfy-table',
  // props: [ 'colConfigs', 'data' ],
  props: {
    colConfigs: {
      type: Array,
      default: () => {
        return [
          // {
          //   // slot: 'slotName',
          //   slot: undefined,
          //   // component: 'componentName'
          //   component: undefined,
          //   // simple attrs for el-table-column
          //   // ...attrs
          //   // prop: 'name',
          //   // label: '名称'
          // }
        ]
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    // defaults
    highlightCurrentRow: {
      default: () => true
    },
    stripe: {
      default: () => true
    },
    border: {
      default: () => true
    },
    fit: {
      default: () => true
    },
    maxHeight: {
      default: () => 380
    },
    
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/grid/simplfyTable.vue